/** All dates are "YYYY-MM-DD" local-time day strings — the same representation
    used throughout Profile so state never has to think about timezones twice. */

export function dayStr(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function daysAgoStr(n: number, from: Date = new Date()): string {
  const d = new Date(from);
  d.setDate(d.getDate() - n);
  return dayStr(d);
}

export function addDays(day: string, n: number): string {
  const d = new Date(day + "T12:00:00");
  d.setDate(d.getDate() + n);
  return dayStr(d);
}

/** b - a, in whole days. Positive when b is after a. */
export function daysBetween(a: string, b: string): number {
  const da = new Date(a + "T12:00:00").getTime();
  const db = new Date(b + "T12:00:00").getTime();
  return Math.round((db - da) / 86400000);
}

/** Stable integer day index (epoch days) — used for SRS due-dates. */
export function epochDay(day: string): number {
  return Math.floor(new Date(day + "T12:00:00").getTime() / 86400000);
}

export function weekdayIndex(day: string): number {
  return new Date(day + "T12:00:00").getDay(); // 0 = Sunday
}
